import React from 'react';
import { style } from 'typestyle';

import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';

import { tableHeadersLine } from '../dataConnectMultiCluster/DataConnectMultiClusterTableHeaders';

export type DataConnectClusterNodesSectionHeadersProps = Readonly<{
  isDefaultPool: boolean;
}>

export function DataConnectClusterNodesSectionHeaders(props: DataConnectClusterNodesSectionHeadersProps) {
  const tooltipPath = imgPath('info_normal.svg');

  return <>
    <tbody>
      <tr>
        <th className={tableHeadersLine} style={{paddingLeft: 5}}>
          <span className={'tb-data-grid-header-text'} data-tb-test-id={'cluster-node-hostname-column-header'}>
            {Messages.dataConnectSiteSettingsClusterNodeHostnameColumnName()}
          </span>
        </th>
        <th className={tableHeadersLine}>
          <span className={'tb-data-grid-header-text'} data-tb-test-id={'cluster-node-status-column-header'}>
            {Messages.dataConnectSiteSettingsClusterNodeStatuscolumnName()}
          </span>
        </th>
        <th className={tableHeadersLine}>
          <span className={'tb-data-grid-header-text'} data-tb-test-id={'cluster-node-ip-column-header'}>
            {Messages.dataConnectSiteSettingsClusterAlertsColumnName()}
          </span>
        </th>
        <th className={`${tableHeadersLine}`}>
          <span className={'tb-data-grid-header-text'} data-tb-test-id={'cluster-node-ip-column-header'}>
            {Messages.dataConnectSiteSettingsClusterNodeIPColumnName()}
          </span>
        </th>
        <th className={tableHeadersLine} style={{textAlign: 'right'}}>
          <span className={'tb-data-grid-header-text'} data-tb-test-id={'cluster-node-ip-column-header'}>
            {Messages.dataConnectSiteSettingsClusterNodeCPUUtilizationColumnName()}
          </span>
        </th>
        <th className={tableHeadersLine} style={{textAlign: 'right'}}>
          <span className={'tb-data-grid-header-text'} data-tb-test-id={'cluster-node-ip-column-header'}>
            {Messages.dataConnectSiteSettingsClusterNodeMemoryUtilizationColumnName()}
          </span>
        </th>
        <th className={tableHeadersLine} data-tb-test-id={'pool-node-actions-column-header'} >
          <span className={'tb-data-grid-header-text'} data-tb-test-id={'pool-node-actions-column-header'}>
            {Messages.dataConnectSiteSettingsPoolActionsColumnName()}
          </span>
        </th>
      </tr>
    </tbody>
  </>;
}

const textAlignCenter = style({
  textAlign: 'center'
});
